import _regenerator from "C:/Users/lptni/\u5F00\u53D1/dev/project/unbox-server/vue-admin/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "C:/Users/lptni/\u5F00\u53D1/dev/project/unbox-server/vue-admin/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.function.name.js";
import api from '@/api';
export default {
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  name: 'AppsEdit',
  data: function data() {
    return {
      title: '',
      appsStatsEnums: [],
      form: {
        name: '',
        appKey: '',
        appToken: '',
        stats: null
      },
      rules: {
        name: [{
          required: true,
          message: '请输入应用名称',
          trigger: 'blur'
        }],
        appKey: [{
          required: true,
          message: '请输入应用key',
          trigger: 'blur'
        }],
        appToken: [{
          required: true,
          message: '请输入应用token',
          trigger: 'blur'
        }],
        stats: [{
          required: true,
          message: '请输入状态',
          trigger: 'blur'
        }]
      }
    };
  },
  methods: {
    getAppsStatsEnums: function getAppsStatsEnums() {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var res;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _context.n = 1;
              return api.GET_ENUMERATION_LIST({
                name: 'apps_stats'
              });
            case 1:
              res = _context.v;
              _this.appsStatsEnums = res.body;
            case 2:
              return _context.a(2);
          }
        }, _callee);
      }))();
    },
    initEunmData: function initEunmData() {
      this.getEnumList('key');
    },
    getEnumList: function getEnumList(name) {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var par, res;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              par = {
                name: name
              };
              _context2.n = 1;
              return api.GET_ENUMERATION_LIST(par);
            case 1:
              res = _context2.v;
              _this2.enumList = res.body;
            case 2:
              return _context2.a(2);
          }
        }, _callee2);
      }))();
    },
    setTitle: function setTitle(title) {
      this.title = title;
    },
    initData: function initData() {
      if (this.$refs.form !== undefined) {
        this.$refs.form.resetFields();
      }
      this.form.name = null;
      this.form.appKey = null;
      this.form.appToken = null;
      this.form.stats = null;
      this.form.appId = null;
    },
    setData: function setData(data) {
      if (this.$refs.form !== undefined) {
        this.$refs.form.resetFields();
      }
      this.form.name = data.name;
      this.form.appKey = data.appKey;
      this.form.appToken = data.appToken;
      this.form.stats = data.stats + '';
      this.form.appId = data.appId;
    },
    updateApi: function updateApi() {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              _context3.n = 1;
              return api.UPDATE_APPS(_this3.form);
            case 1:
              _this3.$emit('initTableData');
              _this3.$message.success('操作成功');
              _this3.handleClose();
            case 2:
              return _context3.a(2);
          }
        }, _callee3);
      }))();
    },
    saveApi: function saveApi() {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              _context4.n = 1;
              return api.SAVE_APPS(_this4.form);
            case 1:
              _this4.$emit('initTableData');
              _this4.$message.success('操作成功');
              _this4.handleClose();
            case 2:
              return _context4.a(2);
          }
        }, _callee4);
      }))();
    },
    save: function save() {
      var _this5 = this;
      this.$refs.form.validate(function (valid) {
        if (valid) {
          if (_this5.form.appId != null) {
            _this5.$confirm('此操作将永久修改该数据, 是否继续?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(function () {
              _this5.updateApi();
            }).catch(function () {
              _this5.$message({
                type: 'info',
                message: '已取消修改'
              });
            });
          } else {
            _this5.saveApi();
          }
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    handleClose: function handleClose(done) {
      this.$emit('close');
    }
  },
  created: function created() {
    this.getAppsStatsEnums();
  }
};